<div class="myads-content" dir="rtl">

  <!-- ① Header row -->
  <div class="section-header mb-4">
    <div class="section-header__copy">
      <span class="section-eyebrow">ניהול המודעות</span>
      <h1>{{ 'sale4you.label.MyAds' | translate }}</h1>
      <p>צפייה, עריכה וניהול של כל המודעות שפרסמת במקום אחד.</p>
    </div>
    <div class="section-header__actions">
      @if (!loading) {
        <span class="results-summary"><strong>{{ filteredAds.length }}</strong> מתוך {{ ads.length }} מודעות</span>
      }
      <a [routerLink]="['/publish']" class="publish-btn">
        <i class="mdi mdi-plus"></i> פרסום מודעה
      </a>
    </div>
  </div>

  @if (actionError) {
    <div class="action-error mb-3" role="alert">
      <i class="mdi mdi-alert-circle-outline"></i>
      <span>{{ actionError }}</span>
      @if (actionErrorNeedsPlan) {
        <a href="/subscriptions" class="action-error__link">למסלולי המנוי</a>
      }
      <button type="button" class="action-error__close" (click)="actionError = ''" aria-label="סגירה">&times;</button>
    </div>
  }

  <!-- ② Stats bar -->
  @if (!loading && ads.length > 0) {
    <div class="stats-bar mb-4">
      <button type="button" class="stat-card stat-card--total" [class.stat-card--selected]="selectedStatusFilter === 'all'" (click)="applyFilter('all','all')">
        <span class="stat-icon"><i class="mdi mdi-view-grid"></i></span>
        <span class="stat-value">{{ stats.total }}</span>
        <span class="stat-label">סה"כ מודעות</span>
      </button>
      <button type="button" class="stat-card stat-card--active" [class.stat-card--selected]="selectedStatusFilter === 'Active'" (click)="applyFilter('all', 'Active')">
        <span class="stat-icon"><i class="mdi mdi-check-circle-outline"></i></span>
        <span class="stat-value">{{ stats.active }}</span>
        <span class="stat-label">פעילות</span>
      </button>
      <button type="button" class="stat-card stat-card--review" [class.stat-card--selected]="selectedStatusFilter === 'inReview'" (click)="applyFilter('all', 'inReview')">
        <span class="stat-icon"><i class="mdi mdi-clock"></i></span>
        <span class="stat-value">{{ stats.inReview }}</span>
        <span class="stat-label">בבדיקה</span>
      </button>
      <button type="button" class="stat-card stat-card--paused" [class.stat-card--selected]="selectedStatusFilter === 'Pause'" (click)="applyFilter('all', 'Pause')">
        <span class="stat-icon"><i class="mdi mdi-pause-circle-outline"></i></span>
        <span class="stat-value">{{ stats.paused }}</span>
        <span class="stat-label">מושהות</span>
      </button>
    </div>
  }

  <!-- ③ Search + filter toggle row -->
  <div class="search-filter-row mb-3">

    <!-- Search bar -->
    <div class="search-bar" [class.search-bar--active]="searchQuery">
      <i class="mdi mdi-magnify search-icon"></i>
      <input
        class="search-input"
        type="text"
        placeholder="חיפוש לפי שם, תיאור, מחיר..."
        dir="rtl"
        autocomplete="off"
        [value]="searchQuery"
        (input)="onSearch($any($event.target).value)">
      @if (searchQuery) {
        <button class="search-clear" (click)="clearSearch()" aria-label="נקה חיפוש">
          <i class="mdi mdi-close"></i>
        </button>
      }
    </div>

    <!-- Filter toggle button -->
    <button class="filter-toggle-btn" (click)="filterOpen = !filterOpen" [class.filter-toggle-btn--open]="filterOpen">
      <i class="mdi mdi-filter-variant"></i>
      <span>סינון</span>
      @if (!filterOpen) {
        @if (selectedFilter !== 'all') {
          <span class="filter-chip">{{ activeTypeLabel() }}</span>
        }
        @if (selectedStatusFilter !== 'all') {
          <span class="filter-chip filter-chip--status">{{ activeStatusLabel() }}</span>
        }
      }
      <i class="mdi filter-toggle-btn__chevron"
        [class.mdi-chevron-down]="!filterOpen"
      [class.mdi-chevron-up]="filterOpen"></i>
    </button>

  </div>

  <!-- ④ Filter body (collapsible) -->
  <div class="filter-bar mb-3" [class.filter-bar--open]="filterOpen">
    <div class="filter-body">
      <div class="filter-group">
        <p class="filter-group-label">סוג מודעה</p>
        <div class="filter-pills">
          @for (f of filters; track f) {
            <button class="fpill" [class.fpill--active]="selectedFilter === f.key" (click)="applyFilter(f.key)">
              {{ f.label }}<span class="fpill-count">{{ f.count }}</span>
            </button>
          }
        </div>
      </div>
      <div class="filter-group">
        <p class="filter-group-label">סטטוס</p>
        <div class="filter-pills">
          @for (s of statusFilters; track s) {
            <button class="fpill fpill--{{ s.cls }}" [class.fpill--active]="selectedStatusFilter === s.key" (click)="applyStatusFilter(s.key)">
              @if (s.key !== 'all') {
                <span class="fpill-dot"></span>
              }
              {{ s.label }}<span class="fpill-count">{{ s.count }}</span>
            </button>
          }
        </div>
      </div>
    </div>
  </div><!-- /filter-bar -->

  <!-- ⑤ Toolbar: sort + view toggle -->
  @if (!loading && filteredAds.length > 0) {
    <div class="toolbar mb-3">
      <div class="toolbar__sort">
        <span class="toolbar__label">מיון:</span>
        @for (s of sortOptions; track s) {
          <button
            class="sort-btn"
            [class.sort-btn--active]="sortKey === s.key"
            (click)="applySort(s.key)">
            {{ s.label }}
          </button>
        }
      </div>
      <div class="toolbar__view">
        <button class="view-btn" [class.view-btn--active]="viewMode === 'grid'" (click)="setView('grid')" title="תצוגת כרטיסים">
          <mat-icon>view_module</mat-icon>
        </button>
        <button class="view-btn" [class.view-btn--active]="viewMode === 'list'" (click)="setView('list')" title="תצוגת רשימה">
          <mat-icon>view_list</mat-icon>
        </button>
      </div>
    </div>
  }

  <!-- Loading -->
  @if (loading) {
    <div class="text-center py-5">
      <div class="spinner-border text-success" role="status"></div>
      <p class="mt-2 text-muted">טוען מודעות...</p>
    </div>
  }

  <!-- ⑦ Smart empty state -->
  @if (!loading && filteredAds.length === 0) {
    <div class="empty-state">
      <i class="mdi {{ emptyStateMsg().icon }} empty-icon"></i>
      <h6 class="mt-3">{{ emptyStateMsg().title }}</h6>
      <p class="text-muted">{{ emptyStateMsg().sub }}</p>
      @if (emptyStateMsg().showCta) {
        <a [routerLink]="['/publish']" class="btn btn-success mt-2">
          פרסם מודעה חדשה
        </a>
      }
    </div>
  }

  <!-- ══════════════════════════════════════════
  GRID VIEW
  ══════════════════════════════════════════ -->
  @if (!loading && filteredAds.length > 0 && viewMode === 'grid') {
    <div class="ads-grid">
      @for (ad of filteredAds; track ad) {
        <div class="ad-card">
          <!-- Image + overlay actions -->
          <div class="ad-img-wrap">
            <img [src]="imgUrl(ad)" [alt]="ad.name" class="ad-img"
              (error)="$any($event.target).src='assets/imgs/placeholder.png'">
              <span class="type-badge">
                <i class="fas {{ typeIcon(ad.resourcetype) }}"></i> {{ typeLabel(ad.resourcetype) }}
              </span>
              <!-- ⑥ Package badge -->
              @if (ad.adsRoute?.title) {
                <span class="package-badge">{{ ad.adsRoute.title }}</span>
              }
              @if (isCouponAd(ad)) {
                <span class="coupon-badge" title="פורסם באמצעות קופון">קופון</span>
              }
              <!-- Quick actions overlay -->
              <div class="card-actions-overlay"
                [class.card-actions-overlay--confirm]="pendingDeleteId === ad['id']"
                [class.card-actions-overlay--warn]="pendingPauseId === ad['id']">
              <!-- Normal actions -->
              @if (pendingDeleteId !== ad['id'] && pendingPauseId !== ad['id']) {
                @if (canPlay(ad)) {
                  <button class="qa-btn qa-btn--play"     (click)="quickAction(ad,'play',$event)"   title="הפעל (המודעה תעבור לאישור מנהל)"><mat-icon>play_circle_outline</mat-icon></button>
                }
                @if (isAdminFrozen(ad)) {
                  <button class="qa-btn" disabled title="המודעה הושהתה על ידי מנהל"><mat-icon>lock_outline</mat-icon></button>
                }
                @if (isCancelled(ad)) {
                  <button class="qa-btn" disabled [title]="cancelledExplanation" [attr.aria-label]="cancelledExplanation"><mat-icon>block</mat-icon></button>
                }
                @if (canResubmit(ad)) {
                  <button class="qa-btn qa-btn--play" [disabled]="resubmittingId === ad['id']" (click)="resubmit(ad, $event)" title="שלח לבדיקה מחדש" aria-label="שלח לבדיקה מחדש"><mat-icon>send</mat-icon></button>
                }
                @if (canPause(ad)) {
                  <button class="qa-btn qa-btn--pause"   (click)="quickAction(ad,'pause',$event)"  title="השהה"><mat-icon>pause_circle_outline</mat-icon></button>
                }
                @if (canDelete(ad)) {
                  <button class="qa-btn qa-btn--delete" (click)="quickAction(ad,'delete',$event)" title="מחק"><mat-icon>delete_outline</mat-icon></button>
                }
                @if (canPromote(ad)) {
                  <button class="qa-btn qa-btn--promote" (click)="openPromote(ad,$event)" title="קידום המודעה"><mat-icon>rocket_launch</mat-icon></button>
                }
                <button class="qa-btn qa-btn--view"                         (click)="openAdDialog(ad)"                title="פרטים"><mat-icon>visibility</mat-icon></button>
              }
              <!-- Delete confirmation -->
              @if (pendingDeleteId === ad['id']) {
                <div class="confirm-box">
                  <span class="confirm-msg">למחוק את המודעה?</span>
                  <div class="confirm-actions">
                    <button class="confirm-btn confirm-btn--yes" (click)="confirmDelete(ad, $event)">
                      <mat-icon>delete_outline</mat-icon> מחק
                    </button>
                    <button class="confirm-btn confirm-btn--no" (click)="cancelDelete($event)">
                      <mat-icon>close</mat-icon> ביטול
                    </button>
                  </div>
                </div>
              }
              <!-- Pause confirmation -->
              @if (pendingPauseId === ad['id']) {
                <div class="confirm-box">
                  <span class="confirm-msg">להשהות את המודעה?</span>
                  <div class="confirm-actions">
                    <button class="confirm-btn confirm-btn--warn" (click)="confirmPause(ad, $event)">
                      <mat-icon>pause_circle_outline</mat-icon> השהה
                    </button>
                    <button class="confirm-btn confirm-btn--no" (click)="cancelPause($event)">
                      <mat-icon>close</mat-icon> ביטול
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
          <!-- Body -->
          <div class="ad-body">
            <div class="ad-title">{{ ad.name }}</div>
            <div class="ad-meta">
              @if (ad.price) {
                <span class="ad-price">₪{{ ad.price | number }}</span>
              }
              <span class="status-badge {{ statusClass(ad.statusAds) }}">{{ statusLabel(ad.statusAds) }}</span>
            </div>
            <!-- ④ Relative date -->
            <div class="ad-date">
              <i class="mdi mdi-clock"></i> {{ timeAgo(ad.createTime) }}
            </div>
            <!-- Coupon epic: NeedsFix reason + resubmit / Cancelled explanation -->
            @if (canResubmit(ad)) {
              <div class="ad-fix" role="note">
                <p class="ad-fix__title">המודעה הוחזרה לתיקון</p>
                @if (ad.rejection_reason) {
                  <p class="ad-fix__reason">{{ ad.rejection_reason }}</p>
                }
                <div class="ad-fix__actions">
                  <button type="button" class="ad-fix__btn" [disabled]="resubmittingId === ad['id']" (click)="resubmit(ad, $event)">
                    {{ resubmittingId === ad['id'] ? 'שולח...' : 'שלח לבדיקה מחדש' }}
                  </button>
                  <button type="button" class="ad-fix__edit" (click)="openAdDialog(ad)">עריכת המודעה</button>
                </div>
              </div>
            }
            @if (isCancelled(ad)) {
              <p class="ad-cancelled-note">{{ cancelledExplanation }}</p>
            }
          </div>
        </div>
      }
    </div>
  }

  <!-- ══════════════════════════════════════════
  LIST VIEW
  ══════════════════════════════════════════ -->
  @if (!loading && filteredAds.length > 0 && viewMode === 'list') {
    <div class="ads-list">
      @for (ad of filteredAds; track ad) {
        <div class="list-item" (click)="openAdDialog(ad)">
          <div class="list-thumb">
            <img [src]="imgUrl(ad)" [alt]="ad.name"
              (error)="$any($event.target).src='assets/imgs/placeholder.png'">
            </div>
            <div class="list-info">
              <div class="list-title">{{ ad.name }}</div>
              <div class="list-meta">
                <span class="sug-type">
                  <i class="fas {{ typeIcon(ad.resourcetype) }}"></i> {{ typeLabel(ad.resourcetype) }}
                </span>
                @if (ad.adsRoute?.title) {
                  <span class="package-tag">{{ ad.adsRoute.title }}</span>
                }
                @if (isCouponAd(ad)) {
                  <span class="coupon-tag" title="פורסם באמצעות קופון">קופון</span>
                }
              </div>
              @if (canResubmit(ad) && ad.rejection_reason) {
                <div class="list-fix-reason">סיבה: {{ ad.rejection_reason }}</div>
              }
              @if (isCancelled(ad)) {
                <div class="list-cancelled-note">{{ cancelledExplanation }}</div>
              }
            </div>
            @if (ad.price) {
              <div class="list-price">₪{{ ad.price | number }}</div>
            }
            <div class="list-date">
              <i class="mdi mdi-clock"></i> {{ timeAgo(ad.createTime) }}
            </div>
            <span class="status-badge {{ statusClass(ad.statusAds) }}">{{ statusLabel(ad.statusAds) }}</span>
            <div class="list-actions" (click)="$event.stopPropagation()">
              <!-- Normal actions -->
              @if (pendingDeleteId !== ad['id'] && pendingPauseId !== ad['id']) {
                @if (canPlay(ad)) {
                  <button class="qa-btn qa-btn--play"     (click)="quickAction(ad,'play',$event)"   title="הפעל (המודעה תעבור לאישור מנהל)"><mat-icon>play_circle_outline</mat-icon></button>
                }
                @if (isAdminFrozen(ad)) {
                  <button class="qa-btn" disabled title="המודעה הושהתה על ידי מנהל"><mat-icon>lock_outline</mat-icon></button>
                }
                @if (isCancelled(ad)) {
                  <button class="qa-btn" disabled [title]="cancelledExplanation" [attr.aria-label]="cancelledExplanation"><mat-icon>block</mat-icon></button>
                }
                @if (canResubmit(ad)) {
                  <button class="qa-btn qa-btn--play" [disabled]="resubmittingId === ad['id']" (click)="resubmit(ad, $event)" title="שלח לבדיקה מחדש" aria-label="שלח לבדיקה מחדש"><mat-icon>send</mat-icon></button>
                }
                @if (canPause(ad)) {
                  <button class="qa-btn qa-btn--pause"   (click)="quickAction(ad,'pause',$event)"  title="השהה"><mat-icon>pause_circle_outline</mat-icon></button>
                }
                @if (canDelete(ad)) {
                  <button class="qa-btn qa-btn--delete" (click)="quickAction(ad,'delete',$event)" title="מחק"><mat-icon>delete_outline</mat-icon></button>
                }
                @if (canPromote(ad)) {
                  <button class="qa-btn qa-btn--promote" (click)="openPromote(ad,$event)" title="קידום המודעה"><mat-icon>rocket_launch</mat-icon></button>
                }
              }
              <!-- Delete confirmation -->
              @if (pendingDeleteId === ad['id']) {
                <button class="confirm-btn confirm-btn--yes" (click)="confirmDelete(ad, $event)">
                  <mat-icon>delete_outline</mat-icon> מחק
                </button>
                <button class="confirm-btn confirm-btn--no" (click)="cancelDelete($event)">
                  <mat-icon>close</mat-icon> ביטול
                </button>
              }
              <!-- Pause confirmation -->
              @if (pendingPauseId === ad['id']) {
                <button class="confirm-btn confirm-btn--warn" (click)="confirmPause(ad, $event)">
                  <mat-icon>pause_circle_outline</mat-icon> השהה
                </button>
                <button class="confirm-btn confirm-btn--no" (click)="cancelPause($event)">
                  <mat-icon>close</mat-icon> ביטול
                </button>
              }
            </div>
          </div>
        }
      </div>
    }

  </div>
